module.exports = __webpack_public_path__ + "static/media/globalSwiper.e8eb50a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/globalSwiper.mp4
// module id = U4Rq
// module chunks = 2